@import '~ss-ui-client/src/constants/spacing.module.less';

.count-display {
  color: var(--grey-700);
}

.toolbar {
  justify-content: space-between;
  align-items: center;
}

.search-input-wrapper {
  align-items: center;
  flex-wrap: nowrap;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  background: var(--white);
  width: 280px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: var(--grey-400);
  }

  &:focus-within {
    border-color: var(--blue-500);
    box-shadow: 0 0 0 1px var(--blue-200);
  }
}

.search-icon {
  color: var(--grey-400);
  width: 14px;
  height: 14px;
  margin-left: @space-8;
  flex-shrink: 0;
}

.search {
  flex: 1;
  min-width: 0;

  // Override Input component default styles for inline search
  input {
    border: none;
    margin-top: 0;
    height: auto;
    padding: @space-8 @space-8;

    &:focus {
      border: none;
    }
  }
}

.clear-search-button {
  flex-shrink: 0;
  color: var(--grey-400);
  padding: @space-4 @space-8;
  min-height: auto;

  &:hover {
    color: var(--grey-600);
  }
}

.clear-search-icon {
  width: 14px;
  height: 14px;
}

.loading-wrapper {
  justify-content: center;
  padding: @space-48;
}

.toolbar-button-icon {
  height: 10px;
  width: 10px;
  margin-right: @space-8;
}
